<template>
	<v-container class="mt-4 ml-2" fluid>
		<v-row>
			<v-col cols="12">
				<v-card class="shadowCard">
					<v-card-title primary-title>
						<span class="text-subtitle-1"><v-icon left>mdi-fingerprint</v-icon>Nómina Semanal Teacher</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						<v-row>
							<!-- <v-col cols="12" md="3" lg="2">
								<v-text-field
									label="Fecha"
									type="date"
									filled
									dense
									hide-details
									v-model="fecha"
								></v-text-field>
							</v-col> -->

							<v-col cols="12" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  hide-details
                  item-text="ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>

				      <v-col cols="12" md="3" lg="2">
				      	<v-select
					      	:items="semanasCiclo"
					      	v-model="selectedHeaders"
					      	label="# Semana"
					      	filled
                  dense
					      	hide-details
					      	item-text="bloque"
					      	item-value="value"
					      	:disabled="!semanasCiclo.length"
				      	></v-select>
				      </v-col> 


				      <v-col cols="12" md="3" lg="2">
				      	<v-radio-group
						      v-model="tipoNomina"
						      column
						      hide-details
						      small
						      class="mt-0 pt-0"
						    >
						      <v-radio
						        label="Teachers"
						        :value="2"
						      ></v-radio>
						    </v-radio-group>
				      </v-col> 

				    </v-row>

				    <v-row>
				    	<v-col cols="12">
				    		<TeacherSabatinaTL 
				    			v-if="tipoNomina == 2 && tipoNominaT == 1 && ciclo && selectedHeaders"
				    			:selectedHeaders="selectedHeaders"
				    			:ciclo="ciclo"
				    		/>
				    	</v-col>
				    </v-row>
			    </v-card-text>
				</v-card> 
			</v-col>
		</v-row>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';


	import Administrativa        from '@/components/nomina/Administrativa.vue';
	import TeacherSabatinaTL     from '@/components/nomina/TeacherSabatinaTL.vue';
	import TeacherQuincena       from '@/components/nomina/TeacherQuincena.vue';

	import validarErrores  from '@/mixins/validarErrores'
	import XLSX            from 'xlsx'
	import funcionesExcel  from '@/mixins/funcionesExcel'

	const SEMANAS_NOMINA_TEACHERS = [
		{ bloque: 'Semana 1', value: 1 },
		{ bloque: 'Semana 2', value: 2 },
		{ bloque: 'Semana 3', value: 3 },
		{ bloque: 'Semana 4', value: 4 },
		{ bloque: 'Semana 5', value: 5 },
	]

	export default {
		components:{
			Alerta,
			carga,
			Administrativa,
			TeacherSabatinaTL,
			TeacherQuincena
		},

		mixins: [ validarErrores, funcionesExcel ],

		data: () => ({
    	// Alertas
			parametros:{
				dialogError: false,
				mensaje: '',
				color: ''
			},

			respuestaAlerta:false,
			loader: true,
			cargar: false,

			encabezados: null,
			encabezados2: null,
			dialogAceptar: false,
			dialogActualizar: false,
			ciclos:[],
			gruposRoles: [],
			pagos: [],
			ciclo:null,
			id_ciclo: 0,

      // Filtros: 
			fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			// fecha: "2024-11-22",
      // fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

			page: 1,
			page2: 1,
			pageCount: 0,
			itemsPerPage: 10,
			entradassalidas: [],
			autorizarNomina: [],
			nominaEstatus: [],
			nominaTeachersSabatino: [],
			nominaTeachersCatorcena: [],
			asistencias: [],
			estatus: null,
			entradassalidasteachers: [],

			selectedHeaders: null,
			semanasCiclo: [],
			_configurandoFiltros: false,
			gruposRoles2:[],

			tipoNominaT: 1,
			tipoNomina: 2
		}),

		watch: {
			ciclo( value, oldValue ){
				if( !value || this._configurandoFiltros ) return
				if( oldValue && oldValue.id_ciclo !== value.id_ciclo ){
					this.actualizarSemanas()
				}
			},
		},

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

		},

		async created () {
			await this.cargarCiclos()
		},

		methods: {

			calcularSemanasCiclo( ciclo ){
				if( !ciclo || !ciclo.fecha_inicio_ciclo || !ciclo.fecha_fin_ciclo ) return []

				const parseDate = ( fecha ) => new Date(fecha.substr(0, 10) + 'T12:00:00')
				const formatDate = ( fecha ) => fecha.toISOString().substr(0, 10)

				const inicio = parseDate(ciclo.fecha_inicio_ciclo)
				const fin = parseDate(ciclo.fecha_fin_ciclo)
				const semanas = []
				let current = new Date(inicio)
				let num = 1

				while( current <= fin ){
					const weekStart = new Date(current)
					const weekEnd = new Date(current)
					weekEnd.setDate(weekEnd.getDate() + 6)
					if( weekEnd > fin ) weekEnd.setTime(fin.getTime())

					semanas.push({
						bloque: `Semana ${ num }`,
						value: num,
						fecha_inicio: formatDate(weekStart),
						fecha_fin: formatDate(weekEnd),
					})

					num++
					current.setDate(current.getDate() + 7)
				}

				return semanas
			},

			actualizarSemanas(){
				const semanasCalculadas = this.calcularSemanasCiclo( this.ciclo )
				this.semanasCiclo = SEMANAS_NOMINA_TEACHERS.map(( semana ) => {
					const rango = semanasCalculadas.find( el => el.value === semana.value )
					return rango ? { ...semana, ...rango } : semana
				})

				const semanaActual = semanasCalculadas.find(
					el => this.fecha >= el.fecha_inicio && this.fecha <= el.fecha_fin
				)

				this.selectedHeaders = semanaActual
					? semanaActual.value
					: this.semanasCiclo[this.semanasCiclo.length - 1].value
			},

			async cargarCiclos(){
				this._configurandoFiltros = true
				this.cargar = true
				this.ciclos = []

				try{
					const response = await this.$http.post('roles.get.ciclos.minomina', { fecha: this.fecha })
					this.ciclos = (response.data.ciclos || []).filter(el => {
						return el.ciclo && el.ciclo.search('FE') === -1 && el.ciclo.search('CICLO') !== -1
					})

					const cicloActual = response.data.ciclo_actual
					if( cicloActual ){
						this.ciclo = this.ciclos.find(el => el.id_ciclo === cicloActual.id_ciclo) || cicloActual
					}else if( this.ciclos.length ){
						this.ciclo = this.ciclos.find(el => {
							const inicio = el.fecha_inicio_ciclo.substr(0, 10)
							const fin = el.fecha_fin_ciclo.substr(0, 10)
							return this.fecha >= inicio && this.fecha <= fin
						}) || this.ciclos[0]
					}

					if( this.ciclo ){
						this.actualizarSemanas()
					}
				}catch( error ){
					let msg = 'Error al cargar ciclos'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}finally{
					this._configurandoFiltros = false
					this.cargar = false
				}
			},
		},
	}
</script>




